export default class Driver {
  constructor(
    driverData,
    address,
    occupations,
    claims,
    convictions,
    qualifications,
    medicalConditions,
    vehicleUseId
  ) {
    this.titleId = driverData.titleId;
    this.genderId = driverData.genderId;
    this.forename = driverData.forename;
    this.initials = driverData.initials;
    this.surname = driverData.surname;
    this.emailAddress = driverData.emailAddress;
    this.telephone = driverData.telephone;
    this.businessTelephone = driverData.businessTelephone;
    this.address = address;
    this.dateOfBirth = driverData.dateOfBirth;
    this.maritalStatusId = driverData.maritalStatusId || "S";
    this.licenceNumber = driverData.licenceNumber;
    this.datePassedTest = driverData.datePassedTest;
    this.licenceTypeId = driverData.licenceTypeId;
    this.licenceRestrictionsId = driverData.licenceRestrictionsId;
    this.licenceCountryOfIssue = driverData.licenceCountryOfIssue || "023";
    this.relationshipId = driverData.relationshipId || "P";
    this.uberDriverRatingId = driverData.uberDriverRatingId;
    this.ukResidenceYears = driverData.ukResidenceYears;
    this.residentSinceBirth = driverData.residentSinceBirth;
    this.mainUser = driverData.mainUser;
    this.motoringOrganisationId = driverData.motoringOrganisationId || "UBCL";
    this.driverPostcode = driverData.driverPostcode;
    this.occupations = occupations || [];
    this.claims = claims || null;
    this.convictions = convictions || null;
    this.qualifications = qualifications || [];
    this.medicalConditions = medicalConditions || null;
    this.vehicleUseId = vehicleUseId;
    this.uberDriverId = driverData.uberDriverId;
    this.insuranceCancelled = driverData.insuranceCancelled;
    this.criminalConvictions = driverData.criminalConvictions;
    this.objectId = driverData.objectId;
    this.objectHistoryId = driverData.objectHistoryId;
  }
}
